// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1CJ89","messages":"Chat_messages__1g7P6","dateDivider":"Chat_dateDivider__1iN1V"};